import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';
import { BaseFieldProps, ContentLoader, EmailField, Heading, Text } from '@frontend/design-system';

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
});

export type PaymentMethodsAddAchFormStripeProps = {
  isLoading: boolean;
  isResendMode?: boolean;
  fieldProps: BaseFieldProps<string, '', HTMLInputElement>;
  className?: string;
};
export const PaymentMethodsAddAchFormStripe = ({
  isLoading,
  isResendMode,
  fieldProps,
  className,
}: PaymentMethodsAddAchFormStripeProps) => {
  const { t } = useTranslation('payments');
  return (
    <div className={classNames('payment-methods__add-ach-form', className)} css={containerStyles}>
      <ContentLoader show={isLoading} />
      <Heading className='add-ach-form__header' level={2}>
        {isResendMode ? t('Resend ACH on File Verification') : t('Save ACH on File')}
      </Heading>
      <EmailField
        className='add-ach-form__email'
        {...fieldProps}
        label={t('Customer Email*')}
        name={'email'}
        placeholder={t('Enter Email')}
      />
      <Text size='medium'>
        {t(
          'Tell customer to add bank account information in the link provided to them via email. whenever ACH is successfully added, it will be automatically marked as the default payment method and will be used for future payments above $250, or over $25 per payment on payment plans.'
        )}
      </Text>
    </div>
  );
};
